import React, { Component } from 'react';
import { string, number, func, objectOf, bool, oneOfType } from 'prop-types';
import classNames from 'classnames';

import { ArrowUpward, ArrowDownward } from '@material-ui/icons';


import styles from './styles.scss';

export class AdsPerformanceSummary extends Component {
  static propTypes = {
    primaryTitle: string,
    primaryData: oneOfType([number, string]).isRequired,
    primaryDataStyle: objectOf(string),
    secondaryTitle: string,
    secondaryData: oneOfType([number, string]).isRequired,
    secondaryDataStyle:objectOf(string),
    evaluationResultTitle: string,
    dateRange: string,
    evaluationFunction: func,
    onCompareDateChange: func,
    isShowChangePercent: bool
  }

  static defaultProps = {
    primaryTitle: 'Avg. visit with ads',
    secondaryTitle: 'Avg. visit without ads',
    evaluationResultTitle: 'Total change',
    isShowChangePercent: true,
    evaluationFunction: (n1, n2) => {
      return ((n1 - n2) / n2 * 100).toFixed(0);
    }
  }

  drawEvaluationResult () {
    const { primaryData, secondaryData, evaluationFunction } = this.props;
    const positiveSign = '+';
    let evalutionNumber;
    let finalReuslt = 'N/A';
    let arrowIcon = null;
 
    if(primaryData !== undefined && secondaryData ){
      evalutionNumber = evaluationFunction && evaluationFunction(parseFloat(primaryData), parseFloat(secondaryData));
      finalReuslt = ( evalutionNumber > 0 ? `${positiveSign}${evalutionNumber}` : evalutionNumber.toString() ) + '%';
      arrowIcon = evalutionNumber == 0 && '-' || evalutionNumber > 0 &&  <ArrowUpward data-test="arrowUpward"/> || <ArrowDownward data-test="arrowDownward"/>;
    }

    const textStyle = {
      [styles.dataGrow]: evalutionNumber > 0,
      [styles.dataDrop]: evalutionNumber < 0
    };

    return(
      <div className={classNames(styles.dataMetric, styles.initialData, textStyle)}>
        <span className={styles.arrowIcon}>{arrowIcon}</span>
        <span data-test="performanceSummaryEvaluation">{finalReuslt}</span>
      </div>
    ) 
  }

  renderSelectedDates = () => {
    const dateRange = this.props.dateRange;
    const cleanDateRange = dateRange ? dateRange.replace(/\s*\d{2}:\d{2}:\d{2}/g, '') : '';
    return (
      <div>{cleanDateRange}</div>
    );
  }

  handleChangeDateRange = (value) => {
    this.props.onCompareDateChange && this.props.onCompareDateChange(value);
  }

  render() {
    const { 
      primaryTitle, 
      primaryData, 
      primaryDataStyle, 
      secondaryTitle,
      secondaryData,
      secondaryDataStyle,
      evaluationResultTitle,
      isShowChangePercent 
    } = this.props;
    const drawEvaluationResult = this.drawEvaluationResult();

    return (
      <div className={styles.adsSummaryContainer}>
        <div className={styles.adsDataContainer}>
          <div className={styles.dataTitle}>{primaryTitle}</div>
          <div data-test="performanceSummaryPrimaryData" className={styles.dataMetric} style={primaryDataStyle}>{Math.round(primaryData).toLocaleString()}</div>
        </div>
        <div className={styles.adsDataContainer}>
          <div className={styles.dataTitle}>{secondaryTitle}</div>
          <div data-test="performanceSummarySecondaryData" className={styles.dataMetric} style={secondaryDataStyle}>{Math.round(secondaryData).toLocaleString()}</div>
        </div>
        {isShowChangePercent && 
          <div className={styles.adsDataContainer}>
            <div className={styles.dataTitle}>{evaluationResultTitle}</div>
            {drawEvaluationResult}
          </div>
        }
      </div>
    )
  }
}

export default AdsPerformanceSummary;